import React from "react";

/**
 * Section heading with center-aligned title and small green divider underneath.
 */
export const SectionHeading = ({ children, testId }) => (
    <div className="text-center" data-testid={testId}>
        <h2 className="text-2xl md:text-3xl font-semibold text-white">
            {children}
        </h2>
        <div className="heading-divider" />
    </div>
);
